import contact from "../../api/contact";
import { perPageCount } from "@/common/constants";
import {
  dummyRows,
  percentageVieW,
  convertCount,
  capitalizeFirstLetter,
} from "@/common/functions";
import moment from "moment";
const chartConfigs = () => import("@/components/Charts/config");

const getDefaultState = () => {
  return {
    items: [],
    editEmailData: [],
    countryListData: [],
    loaded: false,
    dataloaded: false,
    listCountData: [],
    listPerformanceData: [],
    allListCountSummery: [],
    allListPerfomance: [],
    userPerformance: [],
    subscribersList: [],
    userDetails: "",
    filter: {
      page: 1,
      per_page_count: perPageCount,
    },
    listDetails: "",
    userProfileInfo: "",
    emailStatus: "",
    listAnalytics: [],
    domainAnalytics: [],
    deviceAnalytics: [],
    conversionCount: 0,
    domainAnalyticsData: [],
    listAnalyticsProcss: 0,
    domainState: false,
    listAnalyticsCount: 1,
    listAnalyticsSrchCount: 0,
    smtpdomainAnalyticsData: [],
    exportLogId: 0,
    listName: "",
    recipientFilter: {},
    customFieldlist: [],
    customFieldlistTotal: 0,
    noContactAdd: 0,
    customFieldlistLoaded: false,
    customFieldlistFilter: { page: 1, perPageCount: 10 },
  };
};
// initial state
const state = getDefaultState();

// actions
const actions = {
  saveList(_, params) {
    return contact.saveList(params);
  },
  saveCustomField(_, params) {
    return contact.saveCustomField(params);
  },
  refreshCustomField({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("importMapField", state.customFieldlistFilter);
  },
  deleteCustomField({ dispatch }, id) {
    return contact.deleteCustomField(id).then(function () {
      dispatch("refreshCustomField");
    });
  },
  fetchOneList(_, params) {
    return contact.fetchOneList(params);
  },
  mappingData() {
    return contact.mappingData();
  },
  setMappingData(_, params) {
    return contact.setMappingData(params);
  },
  saveList_mappingContact(_, params) {
    return contact.saveList_mappingContact(params);
  },
  getCopyPaisteMaping(_, params) {
    return contact.getCopyPaisteMaping(params);
  },
  saveList_CopyPaistemap(_, params) {
    return contact.saveList_CopyPaistemap(params);
  },
  saveList_sinleContact(_, params) {
    return contact.saveList_sinleContact(params);
  },
  deleteContactWithPlan(_, params) {
    return contact.deleteContactWithPlan(params);
  },

  getListData({ commit }, params) {
    contact.getListData(params, (data) => {
      commit("setListCountData", { items: data.contact_summery });
      commit("setAllListCountSummery", { items: data.all_contact_summery });
      commit("setListPerformance", { items: data.list_performance });
      commit("setListName", data.listName);
    });
  },

  getSubscribersFromList({ commit }, params) {
    return new Promise(function (resolve) {
      contact.getSubscribersFromList(params, (data) => {
        commit("setSubscribersList", { items: data.data.subscribers });
        commit("setListDetails", { items: data.data.list_details });
        resolve(data.data.list_details.totalCount);
      });
    });
  },
  saveExportLog({ commit }, params) {
    contact.saveExportLog(params, (data) => {
      commit("setExportLogId", { items: data.id });
    });
  },

  getSubscriberData({ commit, state }, params) {
    if (!state.dataloaded) {
      contact.getSubscriberData(params, (data) => {
        commit("setEmaildata", true);
        commit("setUserDetails", { items: data.email_data });
        commit("setCountryList", { items: data.country_data });
        commit("setuserProfileInfo", { items: data.email_data });
        commit("setEmailEditData", { items: data });
        commit("setEmailStatus", { items: data.email_data });
      });
    }
  },
  getuserPerfomance({ commit }, params) {
    contact.getuserPerfomance(params, (data) => {
      commit("setUserperfomance", { items: data.emailDtls });
    });
  },
  editSubscriber(_, params) {
    return contact.editSubscriber(params);
  },
  updateSubscriber(_, params) {
    return contact.updateSubscriber(params);
  },
  deleteContact(_, params) {
    return contact.deleteContact(params);
  },

  inactive(_, params) {
    return contact.emailInactive(params);
  },

  getListAnalytics({ commit }, params) {
    contact.getListAnalytics(params, (data) => {
      commit("setListAnalyticsData", { items: data });
    });
  },
  getDeviceDetails({ commit }, params) {
    contact.getDeviceDetails(params, (data) => {
      commit("setDeviceDetails", { items: data });
    });
  },
  refreshStoredData({ commit }) {
    commit("setListCountData", {});
    commit("setAllListCountSummery", {});
    commit("setListPerformance", {});
    commit("setDeviceDetails", {});
    commit("setSubscribersList", {});
    commit("setListDetails", {});
    commit("setListAnalyticsData", {});
  },
  resetState({ commit }) {
    commit("resetState");
  },

  checkbalance() {
    return contact.checkbalance();
  },

  getConverionCount({ commit }, params) {
    contact.getConverionCount(params, (data) => {
      commit("setConversionCount", { items: data });
    });
  },
  domainlistanalytics({ commit }, params) {
    contact.domainlistanalytics(params, (data) => {
      commit("SetListAnalyticsCount", { items: data.rowCount });
      commit("SetListAnalyticsSrhCount", { items: data.list_count });
      commit("setDomainListAnalytics", { items: data.data });
      commit("setListAnalyticsProcessCount", { items: data.processCount });
    });
  },
  smtpdomainanalytics({ commit }, params) {
    contact.smtpdomainanalytics(params, (data) => {
      commit("SetSmtpAnalyticsData", { items: data.statisticsDet });
    });
  },

  sendOtp(_, params) {
    return contact.sendOtp(params);
  },

  getSubscribersExport(_, params) {
    return contact.getSubscribersExport(params);
  },

  importMapField({ commit }, params) {
    commit("setLoaded", false);
    return contact.getListCustomFields(params, (data) => {
      commit("SetListCustomFields", data);
      commit("setLoaded", true);
      commit("setFilter", params);
    });
  },
};

const getLinkProperties = (state) => {
  return state.customFieldlist
    .filter((item) => item.type === "Link")
    .map(({ label, value }) => ({ label, value: `[[${value}]]` }));
};
const getters = {
  getCustomFields: (state) => {
    if (state.customFieldlist.length <= 0) {
      return dummyRows(10);
    }
    let listData = [];
    for (const element of state.customFieldlist) {
      if (element) {
        let data = element;
        listData.push({
          propertyName: data.fieldName,
          propertyTag: data.fieldValue,
          propertyType: data.fieldType,
          propertyDescription: data.fieldDescription,
          defaultProperty: data.cid === 0,
          id: data.id,
        });
      }
    }
    return listData;
  },
  getLinkProperties,
  getLinkPersonalizationTags(state) {
    return getLinkProperties(state).map((item) => item.value);
  },

  getEmailStatus: (state) => {
    let status = "";
    let statusType = "";
    if (state.emailStatus) {
      status = state.emailStatus;

      if (state.emailStatus === "Testmail") {
        status = "Active";
      }
      switch (state.emailStatus) {
        case "Active":
          statusType = "circle-check";
          break;
        case "Unknown":
          statusType = "unknown";
          break;
        case "External verified":
          statusType = "external-verified";
          break;
        case "Suppressed":
          statusType = "light-blue";
          break;
        case "Unsubscribe":
          statusType = "circle-close";
          break;
        case "Spam":
          statusType = "circle-red";
          break;
        case "Bounced":
          statusType = "circle-yellow";
          break;
        case "External group mailbox":
          statusType = "external-group-mailbox";
          break;
        case "Spam Trap":
          statusType = "red";
          break;
        case "External abusers":
          statusType = "external-abusers";
          break;
        case "External invalid":
          statusType = "external-invalid";
          break;
        case "Spam complaints":
          statusType = "spam-complains";
          break;
        case "Frequent abusers":
          statusType = "frequent-abusers";
          break;
        case "External spam complaints":
          statusType = "external-spam-complains";
          break;
        case "Account level bounce":
          statusType = "account-level-bounce";
          break;
        default:
          statusType = "circle-check";
      }
    }

    return { status: status, icon: statusType };
  },

  getListDetails: (state) => {
    return state.listDetails ? state.listDetails : {};
  },

  getListSummery: (state) => {
    var count1 = [];
    var count2 = [];
    var i = 1;
    if (state.listCountData) {
      state.listCountData.forEach(function (entry) {
        for (var key in entry) {
          var keys = capitalizeFirstLetter(key.replace("_", " "));
          if (count1.length >= 2) {
            count2.push({
              text: keys,
              value: convertCount(entry[key]),
              legClass: "bg-" + i,
            });
          } else {
            count1.push({
              text: keys,
              value: convertCount(entry[key]),
              legClass: "bg-" + i,
            });
          }
          i = i + 1;
        }
      });
    }

    return [count1, count2];
  },

  geListPerfomance: (state) => {
    var count1 = [];
    var count2 = [];
    var listCounts = [];
    var loading = true;
    var i = 1;
    for (var key in state.listPerformanceData) {
      loading = false;
      if (key !== "total" && key !== "active") {
        listCounts.push(state.listPerformanceData[key]);
        var keys = capitalizeFirstLetter(key.replace("_", " "));

        if (count1.length >= 2) {
          count2.push({
            text: keys,
            value: convertCount(state.listPerformanceData[key]),
            legClass: "bg-" + i,
          });
        } else {
          count1.push({
            text: keys,
            value: convertCount(state.listPerformanceData[key]),
            legClass: "bg-" + i,
          });
        }
        i++;
      }
    }

    var chartSummery = {
      labels: ["Opens", "Non-openers", "Clicks", "Conversions"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#0096C7", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return { list: [count1, count2], graph: chartSummery, loading: loading };
  },
  getAllListCountSummery: (state) => {
    var array = [];
    var listCounts = [];
    var loading = true;

    if (
      state.allListCountSummery &&
      state.allListCountSummery.total_contact >= 0
    ) {
      loading = false;
      var Total = state.allListCountSummery["total_contact"];
      for (var key in state.allListCountSummery) {
        var keys = key.replace(/_/gi, " ");
        if (key) {
          var logArray = ["valid", "Unknown", "bounced", "spamtrap"];
          if (
            key !== "total_contact" &&
            logArray.indexOf(key) !== -1 &&
            listCounts.length <= 5
          ) {
            listCounts.push(state.allListCountSummery[key]);
          } else if (key === "Hard bounced") {
            listCounts.push(
              Number(state.allListCountSummery["Hard bounced"]) +
                Number(state.allListCountSummery["Account level bounced"])
            );
          }
        }

        keys = capitalizeFirstLetter(
          keys === "total contact" ? "total contacts" : keys
        );
        array.push({
          status: keys,
          percentage:
            percentageVieW(state.allListCountSummery[key], Total) + "%",
          counts: convertCount(state.allListCountSummery[key]),
        });
      }
    }

    var chartSummery = {
      labels: ["Valid", "Unknown", "Bounced", "Spam trap"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#48CAE4", "#0096C7"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };
    return { list: array, graph: chartSummery, loading: loading };
  },
  getAllListPerfomance: (state) => {
    var active = state.listPerformanceData["active"]
      ? state.listPerformanceData["active"]
      : 0;
    var array = [];
    for (var key in state.listPerformanceData) {
      if (key !== "total" && key !== "active") {
        var keys = capitalizeFirstLetter(key.replace("_", " "));
        var percnt = percentageVieW(state.listPerformanceData[key], active);
        if (keys === "Non openers") {
          percnt = percentageVieW(state.listPerformanceData[key], active);
        } else if (keys === "Clicks") {
          percnt = percentageVieW(
            state.listPerformanceData[key],
            state.listPerformanceData["opens"]
          );
        } else if (keys === "Conversions") {
          percnt = percentageVieW(
            state.listPerformanceData[key],
            state.listPerformanceData["clicks"]
          );
        }
        array.push({
          status: keys,
          percentage: percnt + "%",
          counts: convertCount(state.listPerformanceData[key]),
        });
      }
    }

    return array;
  },
  getSubscribersListData: (state) => {
    if (!state.subscribersList) {
      return dummyRows();
    }

    var array = [];

    var statusType = "circle-check";
    if (state.subscribersList) {
      state.subscribersList.forEach(function (entry) {
        switch (entry.emailStatus) {
          case "Active":
            statusType = "circle-check";
            break;
          case "Unknown":
            statusType = "unknown";
            break;
          case "External verified":
            statusType = "external-verified";
            break;
          case "Suppressed":
            statusType = "light-blue";
            break;
          case "Unsubscribe":
            statusType = "circle-close";
            break;
          case "Spam":
            statusType = "circle-red";
            break;
          case "Bounced":
            statusType = "circle-yellow";
            break;
          case "External group mailbox":
            statusType = "external-group-mailbox";
            break;
          case "Spam Trap":
            statusType = "red";
            break;
          case "External abusers":
            statusType = "external-abusers";
            break;
          case "External invalid":
            statusType = "external-invalid";
            break;
          case "Spam complaints":
            statusType = "spam-complains";
            break;
          case "Frequent abusers":
            statusType = "frequent-abusers";
            break;
          case "External spam complaints":
            statusType = "external-spam-complains";
            break;
          case "Account level bounce":
            statusType = "account-level-bounce";
            break;
          default:
            statusType = "circle-check";
        }

        array.push({
          rec_sl_no: entry.slno,
          rec_email: entry.email,
          rec_rating: {
            rating: entry.rating,
            isIndicatorActive: false,
            style: {
              fullStarColor: "#007BFF",
              emptyStarColor: "#ccd6e3",
              starWidth: 17,
              starHeight: 17,
            },
          },
          rec_name: entry.name,
          list_status: entry.listStatus,
          rec_status: {
            text: entry.emailStatus === "Active" ? "Valid" : entry.emailStatus,
            type: statusType,
            value: entry.emlStatus,
          },
          table_action: entry.id,
        });
      });
    }

    return array;
  },

  getProfileInfo: (state) => {
    var array = [];
    var status = "";
    var rating = 0;
    if (state.userDetails.email) {
      array.push({ label: "First name", value: state.userDetails.name });
      array.push({ label: "Middle name", value: state.userDetails.middleName });
      array.push({ label: "Last name", value: state.userDetails.lastName });
      array.push({ label: "Email", value: state.userDetails.email });
      array.push({ label: "Phone", value: state.userDetails.phone });
      array.push({
        label: "Company name",
        value: state.userDetails.organization,
      });
      array.push({ label: "Country", value: state.userDetails.country });
      array.push({ label: "City", value: state.userDetails.city });
      array.push({ label: "Postal code", value: state.userDetails.zip });
      if (state.userDetails.mailboxProvider) {
        array.push({
          label: "Mailbox provider",
          value: state.userDetails.mailboxProvider,
        });
      }
      if (
        state.userDetails.department &&
        state.userDetails.department !== "---"
      ) {
        array.push({
          label: "Department",
          value: state.userDetails.department,
        });
      }
      if (state.userDetails.industry && state.userDetails.industry !== "---") {
        array.push({ label: "Industry", value: state.userDetails.industry });
      }
      if (state.userDetails.jobTitle && state.userDetails.jobTitle !== "---") {
        array.push({ label: "Job title", value: state.userDetails.jobTitle });
      }
      if (state.userDetails.salary !== "---") {
        array.push({ label: "Salary", value: state.userDetails.salary });
      }
      if (state.userDetails.state && state.userDetails.state !== "---") {
        array.push({ label: "State", value: state.userDetails.state });
      }
      if (
        state.userDetails.leadSource &&
        state.userDetails.leadSource !== "---"
      ) {
        array.push({
          label: "Lead source",
          value: state.userDetails.leadSource,
        });
      }

      if (
        state.userDetails.extra_array &&
        state.userDetails.extra_array.length
      ) {
        for (var key in state.userDetails.extra_array) {
          if (
            state.userDetails.extra_array[key].type === "Date" &&
            state.userDetails.extra_array[key].value
          ) {
            var dateView = moment(
              state.userDetails.extra_array[key].value,
              "YYYY-MM-DD"
            );
            array.push({
              label: state.userDetails.extra_array[key].label,
              value: dateView.format("D MMM YYYY "),
            });
          } else if (!state.userDetails.extra_array[key].value) {
            array.push({
              label: state.userDetails.extra_array[key].label,
              value: "---",
            });
          } else {
            array.push({
              label: state.userDetails.extra_array[key].label,
              value: state.userDetails.extra_array[key].value,
            });
          }
        }
      }

      array.push({
        label: "Modified date",
        value: state.userDetails.modifieddate,
      });
      array.push({
        label: "Created date",
        value: state.userDetails.createddate,
      });
      status = state.userDetails.status;
      rating = state.userDetails.rating;
    }
    var Contactrating = {
      rating: rating,
      isIndicatorActive: false,
      style: {
        fullStarColor: "#007BFF",
        emptyStarColor: "#ccd6e3",
        starWidth: 17,
        starHeight: 17,
      },
    };

    return { info: array, emailStatus: status, emailRating: Contactrating };
  },

  getSubscriberDetails: (state) => {
    var emailDetails = {
      email: "",
      rating: "",
      name: "",
      lastName: "",
      middleName: "",
      phone: "",
      organization: "",
      industry: "",
      department: "",
      jobTitle: "",
      state: "",
      zip: "",
      leadSource: "",
      salary: "",
      country: "",
      city: "",
      createddate: "",
      status: "",
      emailName: "",
      EmailName: "",
      sentCnt: 0,
      openCnt: 0,
      clickCnt: 0,
      conversion: 0,
      config: {
        rating: 0,
        isIndicatorActive: false,
        style: {
          fullStarColor: "#F9CA24",
          emptyStarColor: "#ccd6e3",
          starWidth: 20,
          starHeight: 20,
        },
      },
    };

    if (state.userDetails.email) {
      emailDetails = { ...state.userDetails };
      emailDetails.config = {
        rating: state.userDetails.rating,
        isIndicatorActive: false,
        style: {
          fullStarColor: "#F9CA24",
          emptyStarColor: "#ccd6e3",
          starWidth: 20,
          starHeight: 20,
        },
      };

      if (!state.userDetails.name || state.userDetails.name === "---") {
        emailDetails.EmailName = state.userDetails.email?.substring(0, 2);
      } else {
        emailDetails.EmailName = state.userDetails.name?.substring(0, 2);
      }
    }

    emailDetails.emailName = emailDetails.EmailName.toUpperCase();
    emailDetails.conversion = 0;
    return emailDetails;
  },

  getUserActivity: (state) => {
    var array = [];

    state.userPerformance.forEach(function (entry) {
      array.push({
        description: entry.status,
        campaign: entry.campName,
        type: entry.type,
        jobid: entry.jobid,
        date: entry.entryDate,
      });
    });

    return array;
  },
  getDomainAnaltics: (state) => {
    var count1 = [];
    var count2 = [];
    var listArr = [];
    var smtpDmn = [];
    var listcnt = 0;
    var loading = true;
    var listCounts = [];
    if (state.domainAnalytics && state.domainAnalytics.smtpDomain) {
      loading = false;
      listcnt = state.domainAnalytics.list_count;

      var smtpDomain = state.domainAnalytics.smtpDomain;

      for (var key in smtpDomain) {
        listCounts.push(smtpDomain[key]);
      }

      count1.push({
        text: "Gmail",
        value: convertCount(smtpDomain.gmail),
        legClass: "bg-1",
      });
      count1.push({
        text: "Yahoo",
        value: convertCount(smtpDomain.yahoo),
        legClass: "bg-3",
      });
      count2.push({
        text: "Hotmail",
        value: convertCount(smtpDomain.hotmail),
        legClass: "bg-2",
      });
      count2.push({
        text: "Other Domains",
        value: convertCount(smtpDomain.others),
        legClass: "bg-4",
      });
      smtpDmn = [count1, count2];

      var toalActive = state.domainAnalytics.totalActive;

      state.domainAnalytics.data.forEach(function (entry) {
        listArr.push({
          status: entry.emailDomain,
          percentage:
            percentageVieW(parseInt(entry.domainCnt), toalActive) + "%",

          counts: convertCount(parseInt(entry.domainCnt)),
        });
      });
    }

    var chartSummery = {
      labels: ["Gmail", "Yahoo", "Hotmail", "Others"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#0096C7", "#023E8A", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return {
      loading: loading,
      smtpDomain: smtpDmn,
      listArr: listArr,
      graph: chartSummery,
      listCount: listcnt,
    };
  },
  getDeviceAnalytics: (state) => {
    var listCounts = [];
    var osArr = [];
    var arr1 = [];
    var arr2 = [];
    var totalCount = 0;
    var loading = true;
    var i = 1;
    if (state.deviceAnalytics && state.deviceAnalytics.device) {
      loading = false;
      var result = state.deviceAnalytics.device;
      result.forEach(function (entry) {
        totalCount = parseInt(totalCount + entry.count);
        listCounts.push(entry.count);
        if (arr1.length >= 2) {
          arr2.push({
            text: entry.device,
            value: convertCount(entry.count),
            legClass: "bg-" + i,
          });
        } else {
          arr1.push({
            text: entry.device,
            value: convertCount(entry.count),
            legClass: "bg-" + i,
          });
        }
        i = i + 1;
      });
      var osDetls = state.deviceAnalytics.os;
      osDetls.forEach(function (entry) {
        osArr.push({
          status: entry.os.replace("_", " "),
          percentage: entry.percentage + " %",
          counts: convertCount(entry.cnt),
        });
      });
    }

    var chartSummery = {
      labels: ["Desktop", "Mobile", "Console", "Others"],
      datasets: [
        {
          label: "Data One",
          backgroundColor: ["#03045E", "#023E8A", "#0096C7", "#48CAE4"],
          data: listCounts,
        },
      ],
      extraOptions: chartConfigs.pieChartOptions,
    };

    return {
      loading: loading,
      devices: [arr1, arr2],
      deviceslist: osArr,
      graph: chartSummery,
      totalDevices: totalCount,
    };
  },

  getDomainListAnalytics: (state) => {
    if (!state.domainState) {
      return dummyRows();
    }

    var array = [];

    if (state.domainAnalyticsData) {
      state.domainAnalyticsData.forEach(function (entry) {
        array.push({
          list_domain: entry.emailDomain,
          list_total: convertCount(entry.totaldomainCnt),
          list_active: convertCount(entry.valid + entry.unknown),
          list_open: convertCount(entry.opensCnt),
          list_inactive: convertCount(entry.inactiveCnt),
          rec_status: {
            text: entry.domain_blacklist ? "Suppress" : "Active",
            type: entry.domain_blacklist ? "light-blue" : "circle-check",
          },
        });
      });
    }

    return array;
  },
  getSmtpListAnalytics: (state) => {
    if (!state.domainState) {
      return dummyRows();
    }

    var array = [];

    if (state.smtpdomainAnalyticsData) {
      state.smtpdomainAnalyticsData.forEach(function (entry) {
        var activeCnt = parseInt(entry.valid) + parseInt(entry.unknown);
        array.push({
          list_domain: entry.domain,
          list_total: convertCount(entry.totaldomainCnt),
          list_active: convertCount(activeCnt),
          list_open: convertCount(entry.opensCnt),
          list_inactive: convertCount(entry.inactiveCnt),
          rec_status: {
            text: entry.domain_blacklist ? "Suppress" : "Active",
            type: entry.domain_blacklist ? "light-blue" : "circle-check",
          },
        });
      });
    }

    return array;
  },
};

const mutations = {
  setListCountData(state, { items }) {
    state.listCountData = items;
  },
  setListPerformance(state, { items }) {
    state.listPerformanceData = items;
  },
  setAllListCountSummery(state, { items }) {
    state.allListCountSummery = items;
  },

  setAllListPerfomance(state, { items }) {
    state.allListPerfomance = items;
  },
  setSubscribersList(state, { items }) {
    state.subscribersList = items;
  },
  setListDetails(state, { items }) {
    state.listDetails = items;
  },
  setExportLogId(state, { items }) {
    state.exportLogId = items;
  },

  setUserDetails(state, { items }) {
    state.userDetails = items;
  },
  setCountryList(state, { items }) {
    state.countryListData = items;
  },
  setuserProfileInfo(state, { items }) {
    state.userProfileInfo = items;
  },
  setUserperfomance(state, { items }) {
    state.userPerformance = items;
  },
  setListAnalyticsData(state, { items }) {
    state.domainAnalytics = items;
  },

  setEmailEditData(state, { items }) {
    state.editEmailData = items;
  },

  setDeviceDetails(state, { items }) {
    state.deviceAnalytics = items;
  },

  setEmailStatus(state, { items }) {
    state.emailStatus = items.status;
  },
  setConversionCount(state, { items }) {
    state.conversionCount = items.data;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setEmaildata(state, loaded) {
    state.dataloaded = loaded;
  },
  setDomainListAnalytics(state, { items }) {
    state.domainAnalyticsData = items;
    state.domainState = true;
  },
  SetSmtpAnalyticsData(state, { items }) {
    state.smtpdomainAnalyticsData = items;
  },
  setListAnalyticsProcessCount(state, { items }) {
    state.listAnalyticsProcss = items;
  },
  SetListAnalyticsCount(state, { items }) {
    state.listAnalyticsCount = items;
  },
  SetListAnalyticsSrhCount(state, { items }) {
    state.listAnalyticsSrchCount = items;
  },
  setListName(state, data) {
    state.listName = data;
  },
  setRecipientFilter(state, data) {
    state.recipientFilter = data;
  },
  SetListCustomFields(state, data) {
    state.customFieldlist = data.data || data;
    state.customFieldlistTotal = data.totalRows;
    state.customFieldlistLoaded = true;
  },
  setLoaded(state, loaded) {
    state.customFieldlistLoaded = loaded;
  },
  setFilter(state, data) {
    state.customFieldlistFilter = data;
  },
  setNoContactAdd(state, data) {
    state.noContactAdd = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
